import React, { useContext, useEffect } from 'react'
import { Flex, Text } from 'rebass'
import { ReactComponent as WarningIcon } from '../../assets/img/warning-icon.svg'
import { styles as s } from './styles'
import { UneeqContext, useIsSmallScreen } from 'uneeq-react-core'
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert'
import { SnackbarOrigin } from '@material-ui/core/Snackbar'
const styles = s.warning

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export interface State extends SnackbarOrigin {
  open: boolean;
}

interface WarningProps {
  message: string
}
const Warning: React.FC<WarningProps> = ({ message }) => {
  const isSmallScreen = useIsSmallScreen()
  const {
    dispatch,
    config: { warningHiddenAfter }
  } = useContext(UneeqContext)

  const classes = useStyles();
  const [state, setState] = React.useState<State>({
    open: true,
    vertical: isSmallScreen ? 'top' : 'bottom',
    horizontal: isSmallScreen ? 'center' : 'left',
  });
  const { vertical, horizontal, open } = state;

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setState({ ...state, open: false });
    dispatch({ type: 'clearError' })
  };

  return (
    <div className={classes.root}>
      <Snackbar anchorOrigin={{ vertical, horizontal }} open={open} autoHideDuration={warningHiddenAfter} onClose={handleClose} key={vertical + horizontal}>
          <Alert onClose={handleClose} severity="warning">
            {message}
          </Alert>
        </Snackbar>
      <Alert severity="warning">{message}</Alert>
    </div>
  )
}

export default Warning
